import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Trophy, ArrowRight } from 'lucide-react';

const POPUP_KEY = 'mr_comp_popup_seen_v1';
const NEWSLETTER_KEY = 'mr_newsletter_popup_v1';
const NEWSLETTER_COOLDOWN_MS = 14 * 24 * 60 * 60 * 1000; // matches NewsletterPopup

// One-time competition promo popup. To avoid colliding with the newsletter
// popup (which has priority for brand-new visitors), this only schedules itself
// when the newsletter popup is already in its 14-day cooldown — i.e. on return
// visits. The always-on ticker (CompetitionTicker) handles first-visit promotion.
export default function CompetitionPromo() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(POPUP_KEY)) return; // already seen — never again
      const nl = localStorage.getItem(NEWSLETTER_KEY);
      const nlInCooldown = nl && Date.now() - parseInt(nl, 10) < NEWSLETTER_COOLDOWN_MS;
      if (!nlInCooldown) return; // newsletter popup will show this visit — defer
      const t = setTimeout(() => setShowPopup(true), 8000);
      return () => clearTimeout(t);
    } catch {}
  }, []);

  const closePopup = () => {
    setShowPopup(false);
    try { localStorage.setItem(POPUP_KEY, '1'); } catch {}
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4" onClick={closePopup}>
      <div className="bg-[#111115] border border-primary/40 max-w-md w-full max-h-[90vh] overflow-y-auto p-6 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={closePopup} className="absolute top-3 right-3 text-white/40 hover:text-white transition-colors" aria-label="Close">
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-center gap-2 mb-3">
          <Trophy className="w-5 h-5 text-primary" />
          <p className="text-primary text-[10px] font-bold tracking-widest">COMPETITION</p>
        </div>
        <h3 className="text-white font-black text-2xl uppercase leading-tight">Win a Free Sim Racing Experience</h3>
        <p className="text-white/50 text-sm mt-3 leading-relaxed">
          Enter our free monthly draw to win a session on a pro-spec rig at our Bromborough venue — or grab a £5 entry
          into our six-monthly <span className="text-white font-bold">Win a Sim Rig</span> giveaway.
        </p>
        <Link
          to="/competition"
          onClick={closePopup}
          className="mt-5 w-full inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold text-xs tracking-widest px-6 py-3.5 transition-colors"
        >
          ENTER NOW <ArrowRight className="w-4 h-4" />
        </Link>
        <button onClick={closePopup} className="mt-3 w-full text-white/30 hover:text-white/60 text-[10px] font-bold tracking-widest transition-colors">
          MAYBE LATER
        </button>
      </div>
    </div>
  );
}